"use client";

import { c as _c } from "react/compiler-runtime";
import { useId, useState } from "react";
import { DurationInput, type DurationUnit } from "@/components/ui/duration-input";
import { Label } from "@/components/ui/label";
import Switch from "@/components/ui/switch";
interface DurationPopoverContentProps {
  value?: number;
  onChange: (minutes: number | undefined) => void;
  defaultUnit?: DurationUnit;
}
const DEFAULT_MINUTES: Record<DurationUnit, number> = {
  months: 43200,
  weeks: 10080,
  days: 1440,
  hours: 60,
  minutes: 1
};

/** Popover body for editing duration (immediately vs interval). */
export function DurationPopoverContent(t0) {
  const $ = _c(24);
  const {
    value,
    onChange,
    defaultUnit: t1
  } = t0;
  const defaultUnit = t1 === undefined ? "days" : t1;
  const immediateSwitchId = useId();
  const [isBlurred, setIsBlurred] = useState(value === 0);
  const isImmediate = value === 0 && isBlurred;
  let t2;
  if ($[0] !== onChange) {
    t2 = minutes => onChange(minutes ?? 0);
    $[0] = onChange;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsBlurred(true);
    t4 = () => setIsBlurred(false);
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== defaultUnit || $[5] !== isImmediate || $[6] !== t2 || $[7] !== value) {
    t5 = <DurationInput value={value} onChange={t2} defaultUnit={defaultUnit} placeholder="0" disabled={isImmediate} onBlur={t3} onFocus={t4} />;
    $[4] = defaultUnit;
    $[5] = isImmediate;
    $[6] = t2;
    $[7] = value;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== defaultUnit || $[10] !== onChange) {
    t6 = checked => {
      if (checked) {
        onChange(0);
      } else {
        onChange(DEFAULT_MINUTES[defaultUnit]);
      }
    };
    $[9] = defaultUnit;
    $[10] = onChange;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== immediateSwitchId || $[13] !== isImmediate || $[14] !== t6) {
    t7 = <Switch id={immediateSwitchId} size="small" checked={isImmediate} onCheckedChange={t6} />;
    $[12] = immediateSwitchId;
    $[13] = isImmediate;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== immediateSwitchId) {
    t8 = <Label htmlFor={immediateSwitchId} className="text-body font-normal">Immediately</Label>;
    $[16] = immediateSwitchId;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = <div className="flex items-center gap-2">{t7}{t8}</div>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t5 || $[22] !== t9) {
    t10 = <div className="space-y-3">{t5}{t9}</div>;
    $[21] = t5;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}